import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import $ from "jquery";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { Helmet } from "react-helmet";

export default function Profile({ userData, setuserData, setuserDataName }) {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  let navigate = useNavigate();
  function signOut() {
    localStorage.removeItem("token");
    setuserData(null);
    navigate("/login");
  }

  const [name, setname] = useState("");
  const [mail, setmail] = useState("");
  const [phone, setphone] = useState("");
  const [address, setaddress] = useState("");
  const [addressID, setaddressID] = useState(null);
  const [loadingName, setloadingName] = useState(false);
  const [loadingMail, setloadingMail] = useState(false);
  const [loadingPhone, setloadingPhone] = useState(false);
  const [loadingPassword, setloadingPassword] = useState(false);
  const [loadingAddress, setloadingAddress] = useState(false);
  const [errMsgMail, seterrMsgMail] = useState(null);
  const [errMsgPass, seterrMsgPass] = useState(null);
  // console.log (userDet)

  let token = {
    token: localStorage.token,
  };

  // Change Name
  async function handleNameChange(values) {
    try {
      setloadingName(true);
      let { data } = await axios.put(
        `${baseURL}/api/v1/users/updateMe/`,
        values,
        {
          headers: token,
        }
      );
      if (data.message === "success") {
        console.log(data);
        setname(data.user.name);
        setuserDataName(data.user.name);
        setloadingName(false);
        $(".doneMsg").fadeIn(300, () => {
          setTimeout(() => {
            $(".doneMsg").fadeOut(300, () => {
              closeChangeForm("formName", "editName");
              $("#name").val("");
              // signOut();
            });
          }, 1000);
        });
      }
    } catch (error) {
      console.log(error);
      setloadingName(false);
      $(".errName").fadeIn(500, () => {
        setTimeout(() => {
          $(".errName").fadeOut(500);
        }, 1000);
      });
    }
  }

  let validationName = Yup.object({
    name: Yup.string()
      .required("Name is Required")
      .min(3, "Name minlength is 3 chars")
      .max(10, "Name maxlength is 10 chars"),
  });
  let formikName = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: validationName,
    onSubmit: handleNameChange,
  });

  // Change E-mail
  async function handleMailChange(values) {
    try {
      setloadingMail(true);
      let { data } = await axios.put(
        `${baseURL}/api/v1/users/updateMe/`,
        values,
        {
          headers: token,
        }
      );
      if (data.message === "success") {
        setmail(data.user.email);
        setloadingMail(false);
        $(".doneMail").fadeIn(300, () => {
          setTimeout(() => {
            $(".doneMail").fadeOut(300, () => {
              closeChangeForm("formMail", "editMail");
              $("#email").val("");
            });
          }, 1000);
        });
      }
    } catch (error) {
      console.log(error);
      setloadingMail(false);
      seterrMsgMail(`${error.response.data.errors.msg}`);
      $(".errMail").fadeIn(500, () => {
        setTimeout(() => {
          $(".errMail").fadeOut(500);
        }, 1000);
      });
    }
  }

  let validationMail = Yup.object({
    email: Yup.string()
      .required("Email is Required")
      .email("Invalid email address *exemple@yyy.zzz"),
  });
  let formikMail = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationMail,
    onSubmit: handleMailChange,
  });

  // Change Phone Number:
  async function handlePhoneChange(values) {
    try {
      setloadingPhone(true);
      let data = await axios.put(`${baseURL}/api/v1/users/updateMe/`, values, {
        headers: token,
      });
      if (data.data.message === "success") {
        // console.log (data)
        setphone(data.config.data.slice(10, 21));
        setloadingPhone(false);
        $(".donePhone").fadeIn(300, () => {
          setTimeout(() => {
            $(".donePhone").fadeOut(300, () => {
              closeChangeForm("formPhone", "editPhone");
              $("#phone").val("");
            });
          }, 1000);
        });
      }
    } catch (error) {
      console.log(error);
      setloadingPhone(false);
      $(".errPhone").fadeIn(500, () => {
        setTimeout(() => {
          $(".errPhone").fadeOut(500);
        }, 1000);
      });
    }
  }

  let validationPhone = Yup.object({
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^01[0125][0-9]{8}$/, "Phone must be valid Eg-number"),
  });
  let formikPhone = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema: validationPhone,
    onSubmit: handlePhoneChange,
  });

  // Change Password

  async function handlePasswordChange(values) {
    try {
      setloadingPassword(true);
      let data = await axios.put(
        `${baseURL}/api/v1/users/changeMyPassword`,
        values,
        {
          headers: token,
        }
      );

      if (data.data.message === "success") {
        setloadingPassword(false);
        $(".donePass").fadeIn(300, () => {
          setTimeout(() => {
            $(".donePass").fadeOut(300, () => {
              closeChangeForm("formPass", "editPass");
              $("#currentPassword").val("");
              $("#password").val("");
              $("#rePassword").val("");
              signOut();
            });
          }, 1000);
        });
      }
    } catch (error) {
      console.log(error);
      setloadingPassword(false);
      seterrMsgPass(error.response.data.errors.msg);
      $(".errPass").fadeIn(500, () => {
        setTimeout(() => {
          $(".errPass").fadeOut(500);
        }, 1000);
      });
    }
  }
  let validationPassword = Yup.object({
    currentPassword: Yup.string().required("Current Password is required"),
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^[A-Z][a-z0-9]{5,10}$/,
        "Password must start with Capital Letter includes at least 5 and less than 10 chars"
      ),
    rePassword: Yup.string()
      .required("Please reEnter Your Password")
      .oneOf([Yup.ref("password")], "Confirm password does not match"),
  });
  let formikPassword = useFormik({
    initialValues: {
      currentPassword: "",
      password: "",
      rePassword: "",
    },
    validationSchema: validationPassword,
    onSubmit: handlePasswordChange,
  });

  // Add Address:
  async function addAddress(values) {
    try {
      setloadingAddress(true);
      let { data } = await axios.post(`${baseURL}/api/v1/addresses`, values, {
        headers: token,
      });
      if (data.status === "success") {
        setaddress(data.data);
        // let idRes = data.data.map((e) => e._id)
        // setaddressID(idRes)
        setloadingAddress(false);
        $(".doneAdd").fadeIn(300, () => {
          setTimeout(() => {
            $(".doneAdd").fadeOut(300, () => {
              closeChangeForm("formAddress", "editAddress");
              $("#details").val("");
              $("#city").val("");
              $("#phoneA").val("");
              $("#nameA").val("Open this select menu");
            });
          }, 1000);
        });
      }
    } catch (error) {
      console.log(error);
      setloadingAddress(false);
    }
  }

  let validationAddress = Yup.object({
    name: Yup.string().required("Please Choose a place Type "),
    details: Yup.string()
      .required("Address Details is Required")
      .min(5, "Details minlength is 3 chars")
      .max(35, "Details maxlength is 10 chars"),
    city: Yup.string()
      .required("City is Required")
      .min(3, "City minlength is 3 chars")
      .max(10, "City maxlength is 10 chars"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^01[0125][0-9]{8}$/, "Phone must be valid Eg-number"),
  });
  let formikAddress = useFormik({
    initialValues: {
      name: "",
      details: "",
      phone: "",
      city: "",
    },
    validationSchema: validationAddress,
    onSubmit: addAddress,
  });

  async function deleteAddress(id) {
    try {
      const data = await axios.delete(`${baseURL}/api/v1/addresses/${id}`, {
        headers: token,
      });
      if (data.data.status === "success") {
        $(".doneDelete").fadeIn(300, () => {
          setTimeout(() => {
            $(".doneDelete").fadeOut(300);
          }, 1000);
        });
        setaddress(data.data.data);
        let idRes = data.data.data.map((e) => e._id);
        if (!idRes.includes(localStorage.getItem("addresses"))) {
          localStorage.removeItem("addresses");
          setaddressID(localStorage.addresses);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function displayAddresses() {
    try {
      const { data } = await axios.get(`${baseURL}/api/v1/addresses`, {
        headers: token,
      });
      setaddress(data.data);
    } catch (error) {
      console.log(error);
    }
  }

  function pinAddress(id) {
    localStorage.setItem("addresses", id);
    setaddressID(localStorage.getItem("addresses"));
  }
  function unPinAddress(id) {
    localStorage.removeItem("addresses", id);
    setaddressID(localStorage.addresses);
  }

  // Display Data:
  async function getuserData() {
    try {
      const { data } = await axios.get(
        `${baseURL}/api/v1/users/${userData.id}`
      );
      setname(data.data.name);
      setmail(data.data.email);
      setphone(data.data.phone);
      setaddress(data.data.addresses);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getuserData();
    displayAddresses();
  }, [userData]);

  function openChangeForm(
    form,
    btnId,
    id1,
    id2,
    id3,
    id4,
    btnId1,
    btnId2,
    btnId3,
    btnId4
  ) {
    $(`.${form}`).slideDown(200);
    $(`#${btnId}`).fadeOut(100);
    $(`.${id1}`).slideUp(200);
    $(`.${id2}`).slideUp(200);
    $(`.${id3}`).slideUp(200);
    $(`.${id4}`).slideUp(200);
    $(`#${btnId1}`).fadeIn(100);
    $(`#${btnId2}`).fadeIn(100);
    $(`#${btnId3}`).fadeIn(100);
    $(`#${btnId4}`).fadeIn(100);
  }

  function closeChangeForm(form, btnId) {
    $(`.${form}`).slideUp(200);
    $(`#${btnId}`).fadeIn(100);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Profile</title>
      </Helmet>
      <div className="row justify-content-center ">
        <div className="col col-12 col-lg-8">
          {/* name */}
          <div className="row shadow-lg rounded-top w-100 mx-auto p-2 py-3 mt-3 align-items-center">
            <div className="col-lg-8">
              <p className="fw-bold fs-4 text-main m-0">
                Name:{" "}
                <span className="text-dark font-sm">
                  {name ? (
                    `${name.charAt(0).toUpperCase()}${name?.slice(1)}`
                  ) : (
                    <LoadingScreen />
                  )}
                </span>
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <button
                id="editName"
                className=" btn Btn w-100"
                onClick={() =>
                  openChangeForm(
                    "formName",
                    "editName",
                    "formMail",
                    "formPass",
                    "formPhone",
                    "formAddress",
                    "editMail",
                    "editPass",
                    "editPhone",
                    "editAddress"
                  )
                }
              >
                Change Name
              </button>
            </div>
          </div>
          <div
            style={{ display: "none" }}
            className="row shadow-lg w-100 mx-auto p-2 py-3 formName"
          >
            <h2 className="text-main">Change Your Name</h2>
            <p className="alert alert-warning">
              If you want to change the name associated with your Fresh Cart
              account, you may do so below. Be sure to click the Save Changes
              button when you are done
            </p>
            <form onSubmit={formikName.handleSubmit}>
              <label htmlFor="name">Name</label>
              <input
                onChange={formikName.handleChange}
                onBlur={formikName.handleBlur}
                value={formikName.values.name}
                type="text"
                name="name"
                id="name"
                className=" form-control mb-2"
              />
              <div
                style={{ display: "none" }}
                className="alert alert-danger errName"
              >
                Failed to Change name Please try again Later
              </div>
              {formikName.errors.name && formikName.touched.name ? (
                <div className=" alert alert-danger">
                  {formikName.errors.name}
                </div>
              ) : null}
              <div
                style={{ display: "none" }}
                className="alert alert-success doneMsg"
              >
                Name Updated Successfully
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {loadingName ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikName.isValid && formikName.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                  >
                    Save Changes
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formName", "editName")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>

          {/* Mail */}
          <div className="row shadow-lg w-100 mx-auto p-2 py-3 align-items-center">
            <div className="col-lg-8">
              <p className="fw-bold fs-4 text-main m-0">
                Email: <span className="text-dark font-sm">{mail}</span>
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <button
                id="editMail"
                className=" btn Btn w-100"
                onClick={() =>
                  openChangeForm(
                    "formMail",
                    "editMail",
                    "formName",
                    "formPass",
                    "formPhone",
                    "formAddress",
                    "editName",
                    "editPass",
                    "editPhone",
                    "editAddress"
                  )
                }
              >
                Change Mail
              </button>
            </div>
          </div>
          <div
            style={{ display: "none" }}
            className="row shadow-lg w-100 mx-auto p-2 py-3 formMail"
          >
            <h2 className="text-main">Change Your Email</h2>
            <p>Current Email address: {mail}</p>
            <p className="alert alert-warning">
              Enter the new email address you would like to associate with your
              account below
            </p>
            <form onSubmit={formikMail.handleSubmit}>
              <label htmlFor="email">Email</label>
              <input
                onChange={formikMail.handleChange}
                onBlur={formikMail.handleBlur}
                value={formikMail.values.email}
                type="text"
                name="email"
                id="email"
                className=" form-control mb-2"
              />
              <div
                style={{ display: "none" }}
                className="alert alert-danger errMail"
              >
                {errMsgMail}
              </div>
              {formikMail.errors.email && formikMail.touched.email ? (
                <div className=" alert alert-danger">
                  {formikMail.errors.email}
                </div>
              ) : null}
              <div
                style={{ display: "none" }}
                className="alert alert-success doneMail"
              >
                Mail Updated Successfully
              </div>
              <div className=" d-flex justify-content-between align-items-center">
                {loadingMail ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikMail.isValid && formikMail.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                  >
                    Save Changes
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formMail", "editMail")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>

          {/* Password */}
          <div className="row shadow-lg w-100 mx-auto p-2 py-3 align-items-center">
            <div className="col-lg-8">
              <p className="fw-bold fs-4 text-main m-0">
                Password: <span className="text-dark font-sm">********</span>
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <button
                id="editPass"
                className=" btn Btn w-100"
                onClick={() =>
                  openChangeForm(
                    "formPass",
                    "editPass",
                    "formName",
                    "formMail",
                    "formPhone",
                    "formAddress",
                    "editName",
                    "editMail",
                    "editPhone",
                    "editAddress"
                  )
                }
              >
                Edit Password
              </button>
            </div>
          </div>
          <div
            style={{ display: "none" }}
            className="row shadow-lg w-100 mx-auto p-2 py-3 formPass"
          >
            <h2 className="text-main">Change Your Password</h2>
            <p className="alert alert-warning">
              Use the form below to change the password for your Fresh Cart
              account{" "}
            </p>
            <form onSubmit={formikPassword.handleSubmit}>
              <label className="p-0" htmlFor="currentPassword">
                Current Password:
              </label>
              <input
                onChange={formikPassword.handleChange}
                onBlur={formikPassword.handleBlur}
                value={formikPassword.values.currentPassword}
                type="password"
                name="currentPassword"
                id="currentPassword"
                className="form-control mb-2"
              />
              <div
                style={{ display: "none" }}
                className="alert alert-danger errPass"
              >
                {errMsgPass}
              </div>
              {formikPassword.errors.currentPassword &&
              formikPassword.touched.currentPassword ? (
                <div className=" alert alert-danger">
                  {formikPassword.errors.currentPassword}
                </div>
              ) : null}
              <label className="p-0" htmlFor="password">
                Password:
              </label>
              <input
                onChange={formikPassword.handleChange}
                onBlur={formikPassword.handleBlur}
                value={formikPassword.values.password}
                type="password"
                name="password"
                id="password"
                className=" form-control mb-2"
              />
              {formikPassword.errors.password &&
              formikPassword.touched.password ? (
                <div className=" alert alert-danger">
                  {formikPassword.errors.password}
                </div>
              ) : null}
              <label className="p-0" htmlFor="rePassword">
                rePassword:
              </label>
              <input
                onChange={formikPassword.handleChange}
                onBlur={formikPassword.handleBlur}
                value={formikPassword.values.rePassword}
                type="password"
                name="rePassword"
                id="rePassword"
                className=" form-control mb-2"
              />
              {formikPassword.errors.rePassword &&
              formikPassword.touched.rePassword ? (
                <div className=" alert alert-danger">
                  {formikPassword.errors.rePassword}
                </div>
              ) : null}
              <div
                style={{ display: "none" }}
                className="alert alert-success donePass"
              >
                Password Updated Successfully
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {loadingPassword ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikPassword.isValid && formikPassword.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                  >
                    Save Changes
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formPass", "editPass")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>

          {/* phone */}
          <div className="row shadow-lg w-100 mx-auto p-2 py-3 align-items-center">
            <div className="col-lg-8">
              <p className="fw-bold fs-4 text-main m-0">
                Phone Number: <span className="text-dark font-sm">{phone}</span>
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <button
                id="editPhone"
                className=" btn Btn w-100"
                onClick={() =>
                  openChangeForm(
                    "formPhone",
                    "editPhone",
                    "formName",
                    "formMail",
                    "formPass",
                    "formAddress",
                    "editName",
                    "editMail",
                    "editPass",
                    "editAddress"
                  )
                }
              >
                Change Phone Number
              </button>
            </div>
          </div>
          <div
            style={{ display: "none" }}
            className="row shadow-lg w-100 mx-auto p-2 py-3 formPhone"
          >
            <h2 className="text-main">Change Your Phone Number</h2>
            <p>Current Phone Number: {phone}</p>
            <p className="alert alert-warning">
              Enter the new phone number you would like to associate with your
              account below
            </p>
            <form onSubmit={formikPhone.handleSubmit}>
              <label htmlFor="phone">Phone Number</label>
              <input
                onChange={formikPhone.handleChange}
                onBlur={formikPhone.handleBlur}
                value={formikPhone.values.phone}
                type="text"
                name="phone"
                id="phone"
                className=" form-control mb-2"
              />
              <div
                style={{ display: "none" }}
                className="alert alert-danger errPhone"
              >
                Failed to change Phone Number Please try again later
              </div>
              {formikPhone.errors.phone && formikPhone.touched.phone ? (
                <div className=" alert alert-danger">
                  {formikPhone.errors.phone}
                </div>
              ) : null}
              <div
                style={{ display: "none" }}
                className="alert alert-success donePhone"
              >
                Phone Number Updated Successfully
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {loadingPhone ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikPhone.isValid && formikPhone.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                  >
                    Save Changes
                  </button>
                )}
                <button
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formPhone", "editPhone")}
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* address */}
        <div className="col col-12 col-lg-8">
          {/* adddress */}
          <div className="row shadow-lg rounded-bottom w-100 mx-auto py-3 pb-4 align-items-center">
            <div className="col-lg-8">
              <p className="fw-bold fs-4 text-main m-0">
                Addresses:{" "}
                {address.length > 0 ? (
                  ""
                ) : (
                  <span className="text-dark font-sm">
                    No addresses to show
                  </span>
                )}
              </p>
            </div>

            <div className="col-lg-4 text-center">
              <button
                id="editAddress"
                className=" btn Btn w-100"
                onClick={() =>
                  openChangeForm(
                    "formAddress",
                    "editAddress",
                    "formName",
                    "formMail",
                    "formPhone",
                    "formPass",
                    "editName",
                    "editMail",
                    "editPass",
                    "editPhone"
                  )
                }
              >
                Add Address
              </button>
            </div>
          </div>

          {address.length > 0 ? (
            <div className="row shadow-lg rounded-bottom w-100 mx-auto py-3 pb-4 align-items-center">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col" className="d-none d-lg-table-cell">
                      No
                    </th>
                    <th scope="col" className="d-none d-lg-table-cell">
                      Category
                    </th>
                    <th scope="col">Details</th>
                    <th scope="col">City</th>
                    <th scope="col" className="d-none d-lg-table-cell">
                      Phone
                    </th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {address
                    ? address.map((ad, idx) => (
                        <tr key={idx}>
                          <th className="d-none d-lg-table-cell" scope="row">
                            {idx + 1}
                          </th>
                          <td className="d-none d-lg-table-cell">{ad.name}</td>
                          <td>{ad.details}</td>
                          <td>{ad.city}</td>
                          <td className="d-none d-lg-table-cell">{ad.phone}</td>
                          <td>
                            {localStorage.getItem("addresses") === ad._id ? (
                              <button
                                id={`unDefault${ad._id}`}
                                onClick={() => unPinAddress(ad._id)}
                                className="btn btn-sm text-white bg-main"
                                title="Unpin default shipping address"
                              >
                                <i className="fa-solid fa-thumbtack"></i>{" "}
                              </button>
                            ) : (
                              <button
                                id={`makeDefault${ad._id}`}
                                onClick={() => pinAddress(ad._id)}
                                className="btn btn-sm Btn"
                                title="set as default shipping address"
                              >
                                <i className="fa-solid fa-thumbtack"></i>{" "}
                              </button>
                            )}
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                deleteAddress(ad._id);
                              }}
                              className="btn btn-outline-danger btn-sm "
                            >
                              <i className="fa-regular fa-trash-can"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
          ) : (
            ""
          )}

          <div
            style={{ display: "none" }}
            className="row shadow-lg rounded-bottom w-100 mx-auto py-3 pb-4 align-items-center formAddress"
          >
            <form onSubmit={formikAddress.handleSubmit}>
              <div className="form-floating mb-3">
                <select
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.name}
                  className="form-select"
                  name="name"
                  id="nameA"
                >
                  <option className="text-main">Open this select menu</option>
                  <option value="home">Home</option>
                  <option value="business">Business</option>
                  <option value="other">Other</option>
                </select>
                <label className="text-main" htmlFor="nameA">
                  Choose Place Type:
                </label>
                {formikAddress.errors.name ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.name}
                  </div>
                ) : null}
              </div>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.details}
                  name="details"
                  type="text"
                  className=" form-control"
                  id="details"
                />
                <label className="text-main" htmlFor="details">
                  Address Details:
                </label>
                {formikAddress.errors.details &&
                formikAddress.touched.details ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.details}
                  </div>
                ) : null}
              </div>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.city}
                  name="city"
                  type="text"
                  className=" form-control"
                  id="city"
                />
                <label className="text-main" htmlFor="city">
                  City:
                </label>
                {formikAddress.errors.city && formikAddress.touched.city ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.city}
                  </div>
                ) : null}
              </div>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.phone}
                  name="phone"
                  type="tel"
                  className=" form-control"
                  id="phoneA"
                />
                <label className="text-main" htmlFor="phoneA">
                  Phone:
                </label>
                {formikAddress.errors.phone && formikAddress.touched.phone ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.phone}
                  </div>
                ) : null}
              </div>
              <div
                style={{ display: "none" }}
                className="alert alert-success doneAdd"
              >
                Address added successfully
              </div>
              <div
                style={{ display: "none" }}
                className="alert alert-danger doneDelete"
              >
                Address removed successfully
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {loadingAddress ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikAddress.isValid && formikAddress.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                  >
                    Submit
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formAddress", "editAddress")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
